import React, { useContext } from "react";
import IntroImg from "../../components/introImg/IntroImg";
import Footer from "../../components/footer/Footer";
import Portfolio from "../../components/Portfolio/Works";
import About from "../../components/About/About";
import Contact from "../../components/contact/Contact";
import Resume from "../../components/Resume/Resume";

import Skills from "../../components/TechStack/Skills";
import "./home.css";
import { ThemeContext } from "../../context/ThemeContext";
export default function Home() {
  const theme = useContext(ThemeContext);
  const darkMode = theme.state.darkMode;
  return (
    <div className="homePage">
      <div
        className="homeContainer"
        style={{
          backgroundColor: darkMode ? "#333333" : "",
          color: darkMode ? "#f5f5f5" : "inherit",
        }}
      >
        <IntroImg />
        <Skills />
        <Portfolio />
        <About />
        <Resume />
        <Contact />
        <Footer />
      </div>
    </div>
  );
}
